import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Address, PersonalDetails } from 'components/forms'
import { LabeledText, Title } from 'components/misc'

class PaymentInfoDetails extends React.PureComponent {

  static propTypes = {
    postalAddress: PropTypes.bool,
    showTitle: PropTypes.bool,
    showMiddleName: PropTypes.bool,
    showAddressLine1: PropTypes.bool,
    showAddressLine2: PropTypes.bool,
    showSecondaryEmail: PropTypes.bool,
    showPhone: PropTypes.bool,
    showPhoneType: PropTypes.bool,
    showCity: PropTypes.bool,
    showZipCode: PropTypes.bool,
    showRegion: PropTypes.bool,
    showCountry: PropTypes.bool
  }

  render() {
    const {
      isEditing,
      genders,
      countries,
      errors,
      nationalities,
      employmentStatuses,
      participant,
      postalAddress,
      showTitle,
      showMiddleName,
      showAddressLine1,
      showAddressLine2,
      showPhone,
      showCity,
      showZipCode,
      showRegion,
      showCountry
    } = this.props


    const showAddress = showAddressLine1 || showAddressLine2 || showCity || showZipCode || showRegion || showCountry

    if (isEditing) {
      return (
        <div>
          <PersonalDetails
            genders={genders}
            nationalities={nationalities}
            employmentStatuses={employmentStatuses}
            errors={errors}
            isPayment
            showTitle={showTitle}
            showMiddleName={showMiddleName}
            isOrganizationContact={false}
          />
          <div>
            <Title h2>
              <FormattedMessage
                id='moduleTitle.address'
                defaultMessage='Address'
              />
            </Title>
            <Address
              isPayment
              countries={countries}
              showFirstLine={showAddressLine1}
              showSecondLine={showAddressLine2}
              showCity={showCity}
              showZipCode={showZipCode}
              showRegion={showRegion}
              showCountry={showCountry}
              showPhone={showPhone}
            />
          </div>

          {postalAddress && get(participant, 'postalAddress') && (
            <div>
              <Title h2>
                <FormattedMessage
                  id='moduleTitle.postal_address'
                  defaultMessage='Postal Address'
                />
              </Title>
              <Address prefix='postal' isPayment isPostal countries={countries} />
            </div>
          )}
        </div>
      )
    }

    return (
      <div>
        <LabeledText
          label='Name'
          intlKey='label.name'
          value={get(participant, 'name')}
        />
        <LabeledText
          label='Birthdate'
          intlKey='label.birthdate'
          value={get(participant, 'birthDate')}
        />
        <LabeledText
          label='Gender'
          intlKey='label.gender'
          value={get(participant, 'gender')}
        />
        {nationalities &&
        <LabeledText
          label='Nationality'
          intlKey='label.nationality'
          value={get(participant, 'nationality')}
        />}
        {employmentStatuses &&
        <LabeledText
          label='Employment status'
          intlKey='label.employment_status'
          value={get(participant, 'employmentStatus')}
        />}
        <br />
        {showAddress && <LabeledText
          label='Address'
          intlKey='label.address'
          multiLine
          value={get(participant, 'address')}
        />}
        {postalAddress && get(participant, 'postalAddress') && (
          <LabeledText
            label='Postal address'
            intlKey='label.postal_address'
            multiLine
            value={get(participant, 'postalAddress')}
          />
        )}
        <LabeledText
          label='Email'
          intlKey='label.email'
          value={get(participant, 'email')}
        />
        {showPhone && <LabeledText
          label='Phone'
          intlKey='label.phone'
          value={get(participant, 'phoneNumber')}
        />}
      </div>
    )
  }
}

PaymentInfoDetails.propTypes = {
  isEditing: PropTypes.bool,
  genders: PropTypes.array,
  errors: PropTypes.object,
  nationalities: PropTypes.array,
  employmentStatuses: PropTypes.array,
  countries: PropTypes.array,
  participant: PropTypes.object,
  postalAddress: PropTypes.bool
}

PaymentInfoDetails.displayName = 'PaymentInfoDetails'

export default PaymentInfoDetails
